import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';
import { ProjectStore } from '@frontend-site/shared/core';
import { NotificationData, UserNotificationsService } from '@frontend-site/main-header/domain';

@Component({
    selector: 'p-user-item',
    templateUrl: './user-item.component.html',
    styleUrls: ['./user-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserItemComponent {
    showRemoveIcon = false;
    @Input() item: NotificationData = {} as NotificationData;
    @Output() closeEvent = new EventEmitter();
    selectedProjectId$ = this.projectStore.projectId$;

    constructor(private userNotificationsService: UserNotificationsService, private projectStore: ProjectStore) {}

    removeNotification(): void {
        this.userNotificationsService.removeNotificationById(this.item).subscribe();
    }

    itemClicked($event: MouseEvent, selectedProjectId: number | null): void {
        this.removeNotification();

        if (selectedProjectId && !this.projectStore.projectDetails?.rdxEnabled) {
            this.item = { ...this.item, linkPath: this.item.linkPath.replace('development', 'requirements') };
        }

        if (!selectedProjectId || selectedProjectId !== this.item.projectId) {
            $event.preventDefault();
            const win = window.open(this.item.linkPath, '_blank');
            win?.focus();
        }
    }
}
